import axios from 'axios'
import {apiUrl} from '@/api/base.js'

export default {
    get_lesson_info (courseId,lessonId) {
        return axios.get(`${apiUrl}v2/courses/${courseId}/learning`,{params: {'id':lessonId}})
    },
    set_lesson_progress (routeParams,curTime) {
        return axios.get(`${apiUrl}v2/set_lesson_progress`,{params: {'routeParams':routeParams,'curTime':curTime}})
    },
    get_lesson_progress (lessonId) {
        return axios.get(`${apiUrl}v2/get_lesson_progress`,{params: {'id':lessonId}})
    }
}
